import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
// import AlertCreateModal from './Create';
// import AlertEditModal from './Edit';
import ViewModal from './ViewModal';
import { Button } from "react-bootstrap";
import TicketFilter from './TicketFIlter';
import TicketViewSide from './TicketSideView';

const TicketsPage = () => {
    const [isView, setIsView] = useState(false)
    const [isFilter, setIsFilter] = useState(false)
    const columns = [
        {
            name: 'Paid ',
            selector: row => row.paid,
            sortable: true,
        },
        {
            name: 'POD ',
            selector: row => row.pod,
            sortable: true,
        },
        {
            name: 'League  ',
            selector: row => row.league,
            sortable: true,
        },
        {
            name: 'Team Name ',
            selector: row => row.teamName,
            sortable: true,
        },
        {
            name: 'Email  ',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Section',
            selector: row => row.section,
            sortable: true,
        },
        {
            name: 'Seat #',
            selector: row => row.seatNo,
            sortable: true,
        },
        {
            name: 'Row ',
            selector: row => row.rowNo,
            sortable: true,
        },
        {
            name: 'Cost  ',
            selector: row => row.cost,
            sortable: true,
        },
        {
            name: 'Total Cost ',
            selector: row => row.totalCost,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            <Button
                                aria-label="View"
                                onClick={() => setIsView(true)}
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-eye-line" />
                            </Button>
                            <Link
                                aria-label="Edit"
                                to="/edit-ticket"
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-edit-line" />
                            </Link>
                            <a
                                aria-label="Delete"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line" />
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const data = [
        {
            paid: 'paid',
            pod: '123456',
            league: 'Premier League',
            teamName: 'Manchester United',
            email: 'example1@example.com',
            section: 'VIP',
            seatNo: 'A123',
            rowNo: '1',
            cost: 150,
            totalCost: 150
        },
        {
            paid: 'unpaid',
            pod: '789012',
            league: 'La Liga',
            teamName: 'Real Madrid',
            email: 'example2@example.com',
            section: 'General',
            seatNo: 'B456',
            rowNo: '2',
            cost: 100,
            totalCost: 200
        },
        {
            paid: 'paid',
            pod: '345678',
            league: 'Serie A',
            teamName: 'AC Milan',
            email: 'example3@example.com',
            section: 'VIP',
            seatNo: 'C789',
            rowNo: '3',
            cost: 200,
            totalCost: 400
        },
        {
            paid: 'unpaid',
            pod: '901234',
            league: 'Bundesliga',
            teamName: 'Bayern Munich',
            email: 'example4@example.com',
            section: 'General',
            seatNo: 'D012',
            rowNo: '4',
            cost: 120,
            totalCost: 240
        },
        {
            paid: 'paid',
            pod: '567890',
            league: 'Ligue 1',
            teamName: 'Paris Saint-Germain',
            email: 'example5@example.com',
            section: 'VIP',
            seatNo: 'E345',
            rowNo: '5',
            cost: 180,
            totalCost: 540
        },
        {
            paid: 'unpaid',
            pod: '234567',
            league: 'Premier League',
            teamName: 'Liverpool',
            email: 'example6@example.com',
            section: 'General',
            seatNo: 'F678',
            rowNo: '6',
            cost: 90,
            totalCost: 270
        },
        {
            paid: 'paid',
            pod: '890123',
            league: 'La Liga',
            teamName: 'FC Barcelona',
            email: 'example7@example.com',
            section: 'VIP',
            seatNo: 'G901',
            rowNo: '7',
            cost: 220,
            totalCost: 660
        },
        {
            paid: 'unpaid',
            pod: '456789',
            league: 'Serie A',
            teamName: 'Juventus',
            email: 'example8@example.com',
            section: 'General',
            seatNo: 'H234',
            rowNo: '8',
            cost: 130,
            totalCost: 390
        },
        {
            paid: 'paid',
            pod: '012345',
            league: 'Bundesliga',
            teamName: 'Borussia Dortmund',
            email: 'example9@example.com',
            section: 'VIP',
            seatNo: 'I567',
            rowNo: '9',
            cost: 240,
            totalCost: 720
        },
        {
            paid: 'unpaid',
            pod: '678901',
            league: 'Ligue 1',
            teamName: 'Olympique Lyonnais',
            email: 'example10@example.com',
            section: 'General',
            seatNo: 'J890',
            rowNo: '10',
            cost: 110,
            totalCost: 330
        }
    ];

    return (
        <>
            <PageHeader name="Tickets" />
            <div className="main-container container-fluid">
                {" "}
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6 ">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0">Total Cost</p>
                                        <span className="fs-5">12,000</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-primary-transparent text-primary">
                                            <i className="fe  fs-18" >$</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 ">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0"># of Seats</p>
                                        <span className="fs-5">120</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-secondary-transparent text-secondary">
                                            <i className="fe fe-package fs-18" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0"># of Accounts</p>
                                        <span className="fs-5">77</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-warning-transparent text-warning">
                                            <i className="fe fe-user fs-18" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex">
                                        <Link to="/create-ticket" className="btn btn-primary">
                                            Create Ticket
                                        </Link>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => setIsFilter(true)}
                                        >
                                            <i className="ri-filter-2-fill"/>
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0 ms-auto">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">


                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* <AlertCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <AlertEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            />*/}
            <TicketViewSide
                show={isView}
                close={() => setIsView(false)}
            />
            <TicketFilter
                show={isFilter}
                close={() => setIsFilter(false)}
            />
        </>
    );
};

export default TicketsPage;